// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MarkAsExportedModal_component_dropdown__16D_B","label":"MarkAsExportedModal_component_label__1Bk9w"};